export default __webpack_public_path__ + "static/media/boosty_1499.d8d54a01.png";